<template>
  <div>
    <div class="email-leftbar card">
        <h6 class="mt-1 mb-1">Controles de Interatividade</h6>
        <div class="mail-list mt-1">
          <a href="javascript: void(0);">
            Chat
            <b-form-checkbox v-model="settings.chat" switch class="ml-1 mb-0 mt-1 float-right" @change="toggleControl('chat', settings.chat)"></b-form-checkbox>
          </a>
          <a href="javascript: void(0);">
            Eomjis
            <b-form-checkbox v-model="settings.emoji" switch class="ml-1 mb-0 mt-1 float-right" @change="toggleControl('emoji', settings.emoji)"></b-form-checkbox>
          </a>
          <a href="javascript: void(0);">
            Perguntas
            <b-form-checkbox v-model="settings.asking" switch class="ml-1 mb-0 mt-1 float-right" @change="toggleControl('asking', settings.asking)"></b-form-checkbox>
          </a>
          <a href="javascript: void(0);">
            Quiz
            <b-form-checkbox v-model="settings.quiz" switch class="ml-1 mb-0 mt-1 float-right" @change="toggleControl('quiz', settings.quiz)"></b-form-checkbox>
          </a>
          <a href="javascript: void(0);">
            Enquete
            <b-form-checkbox v-model="settings.poll" switch class="ml-1 mb-0 mt-1 float-right" @change="toggleControl('poll', settings.poll)"></b-form-checkbox>
          </a>
          <a href="javascript: void(0);">
            Nuvem de Palavras
            <b-form-checkbox v-model="settings.word_cloud" switch class="ml-1 mb-0 mt-1 float-right" @change="toggleControl('word_cloud', settings.word_cloud)"></b-form-checkbox>
          </a>
          <a href="javascript: void(0);">
            Perguntas Públicas
            <b-form-checkbox v-model="settings.public_questions" switch class="ml-1 mb-0 mt-1 float-right" @change="toggleControl('public_questions', settings.public_questions)"></b-form-checkbox>
          </a>
          <a href="javascript: void(0);">
            Call to Action
            <b-form-checkbox v-model="settings.call_action" switch class="ml-1 mb-0 mt-1 float-right" @change="toggleControl('call_action', settings.call_action)"></b-form-checkbox>
          </a>
          <a href="javascript: void(0);">
            Patrocinadores
            <b-form-checkbox v-model="settings.sponsors" switch class="ml-1 mb-0 mt-1 float-right" @change="toggleControl('sponsors', settings.sponsors)"></b-form-checkbox>
          </a>
          <a href="javascript: void(0);">
            Banners
            <b-form-checkbox v-model="settings.banners" switch class="ml-1 mb-0 mt-1 float-right" @change="toggleControl('banners', settings.banners)"></b-form-checkbox>
          </a>
        </div>
        <div class="text-center mt-3 mb-2">
          <button type="button" class="btn btn-sm btn-primary btn-rounded" @click="openInteractionsModal()">
            <i class="mdi mdi-cog-outline"></i> Ajustar interações
          </button>
        </div>
    </div>

    <!-- Modal de Ajuste de Interações -->
    <b-modal
      id="modal-interactions"
      ref="modal-interactions"
      title="Ajustar Interações Visíveis"
      title-class="font-18"
      size="md"
      :no-close-on-backdrop="true"
    >
      <p class="text-muted mb-3">
        Selecione até <strong>5 interações</strong> que ficarão visíveis nos tabs da plataforma.
        Arraste para reordenar a sequência de exibição.
        <br><small><strong>Nota:</strong> As interações só aparecerão se estiverem habilitadas nos "Controles de Interatividade".</small>
      </p>

      <draggable v-model="visibleInteractionsList" :options="{animation:200}" class="list-group">
        <div
          v-for="interaction in visibleInteractionsList"
          :key="interaction.key"
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'bg-light': !interaction.visible}"
        >
          <div class="d-flex align-items-center">
            <i class="mdi mdi-drag-vertical text-muted mr-2" style="cursor: move;"></i>
            <span>{{ interaction.label }}</span>
          </div>
          <b-form-checkbox
            v-model="interaction.visible"
            switch
            @change="validateVisibleLimit"
          ></b-form-checkbox>
        </div>
      </draggable>

      <div v-if="visibleCount > 5" class="alert alert-danger mt-3 mb-0">
        <i class="mdi mdi-alert-circle-outline mr-1"></i>
        Você selecionou {{ visibleCount }} interações. O limite são 5 interações visíveis.
      </div>
      <div v-else class="alert alert-info mt-3 mb-0">
        <i class="mdi mdi-information-outline mr-1"></i>
        {{ visibleCount }} de 5 interações selecionadas.
      </div>

      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="closeInteractionsModal()">Cancelar</b-button>
        <b-button
          variant="primary"
          @click="saveVisibleInteractions()"
          :disabled="visibleCount > 5"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import roomService from '@/pages/rooms/services'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapGetters } from 'vuex'

export default {
  components: {
    draggable
  },
  props: {
    controls: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      loading: true,
      settings: {
        chat: false,
        emoji: false,
        asking: false,
        quiz: false,
        poll: false,
        call_action: false,
        word_cloud: false,
        limit_word_cloud: false,
        public_questions: false,
        public_questions_moderation: 1,
        public_questions_limit_per_user: 0,
        partner: false
      },
      visibleInteractionsList: [],
      allInteractions: [
        { key: 'chat', label: 'Chat', visible: false },
        { key: 'emoji', label: 'Emojis', visible: false },
        { key: 'asking', label: 'Perguntas', visible: false },
        { key: 'quiz', label: 'Quiz', visible: false },
        { key: 'poll', label: 'Enquete', visible: false },
        { key: 'word_cloud', label: 'Nuvem de Palavras', visible: false },
        { key: 'public_questions', label: 'Perguntas Públicas', visible: false }
      ]
    }
  },
  mounted () {
  },
  beforeMount () {
    this.getSettings()
  },
  computed: {
    ...mapGetters('room', {
      setting: 'SETTING'
    }),
    visibleCount () {
      return this.visibleInteractionsList.filter(i => i.visible).length
    }
  },
  methods: {
    toggleControl (key, status) {
      if (status !== '') {
        // CTA e Patrocinadores são mutuamente exclusivos
        if (key === 'call_action' && status) {
          this.settings.sponsors = false
          this.settings.banners = false
        } else if (key === 'sponsors' && status) {
          this.settings.call_action = false
          this.settings.banners = false
        } else if (key === 'banners' && status) {
          this.settings.call_action = false
          this.settings.sponsors = false
        }

        let payload = {
          [key]: status ? 1 : 0,
          id: this.$route.params.id
        }
        roomService.toogleSetting(payload)
          .then((data) => {
            successMessage('Sucesso: ' + data.data.message, 2500)
          }).catch((error) => {
            this.settings[key] = false
            errorMessage('Atenção: ' + error.message)
          })
      }
    },
    getSettings () {
      let loader = this.$loading.show()
      this.settings = this.setting
      loader.hide()
    },
    openInteractionsModal () {
      // Inicializa a lista com base nas interações habilitadas e na configuração atual
      this.loadVisibleInteractions()
      this.$refs['modal-interactions'].show()
    },
    closeInteractionsModal () {
      this.$refs['modal-interactions'].hide()
    },
    loadVisibleInteractions () {
      // Carrega as interações visíveis salvas
      const savedVisible = this.settings.visible_interactions || []

      // Se não houver configuração salva, mostra todas como não visíveis
      if (savedVisible.length === 0) {
        this.visibleInteractionsList = this.allInteractions.map(interaction => ({
          ...interaction,
          visible: false
        }))
      } else {
        // Ordena e marca baseado na configuração salva
        const orderedList = []

        // Primeiro adiciona as que estão na configuração salva, na ordem
        savedVisible.forEach(saved => {
          const found = this.allInteractions.find(i => i.key === saved.key)
          if (found) {
            orderedList.push({
              ...found,
              visible: saved.visible
            })
          }
        })

        // Depois adiciona as interações que não estavam na config salva
        this.allInteractions.forEach(interaction => {
          if (!orderedList.find(i => i.key === interaction.key)) {
            orderedList.push({
              ...interaction,
              visible: false
            })
          }
        })

        this.visibleInteractionsList = orderedList
      }
    },
    validateVisibleLimit () {
      // Validação em tempo real (já feita pelo computed visibleCount)
    },
    saveVisibleInteractions () {
      if (this.visibleCount > 5) {
        errorMessage('Atenção: O limite são 5 interações visíveis.')
        return
      }

      const visibleConfig = this.visibleInteractionsList.map((item, index) => ({
        key: item.key,
        visible: item.visible,
        order: index
      }))

      const payload = {
        id: this.$route.params.id,
        visible_interactions: visibleConfig
      }

      let loader = this.$loading.show()
      roomService.toogleSetting(payload)
        .then(() => {
          successMessage('Configurações de visibilidade salvas com sucesso!', 2500)
          this.closeInteractionsModal()
          // Atualiza as settings locais
          this.settings.visible_interactions = visibleConfig
          loader.hide()
        })
        .catch((error) => {
          loader.hide()
          errorMessage('Erro: ' + (error.response?.data?.message || error.message))
        })
    }
  }
}
</script>
<style>
.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #5fc78a;
    background-color: #33b46d;
}
</style>
